import { InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React from 'react';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import { FieldDate } from 'src/components/redux-form/fields/FieldDate';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/payroll-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asyncPersistPayroll } from 'src/store/actions/payroll-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import PrlProviderGridProviders from './PrlProviderGridProviders';
export interface PayrollFormData {
    id: string | number;
    dateFrom: string;
    note: string;
    status: number;
    dateTo: string;
    providers: any;
    noReload?: boolean;
}

interface PayrollFormProps {
    findProviders: () => void;
    stateData: any;
    isFindProviders: boolean;
    setStateData: (data: any) => void;
    providersPayroll: any;
    handleSub: (data: (e: any) => void, e: any) => void;
}

type InjectedProps = InjectedFormProps<PayrollFormData, PayrollFormProps>;

const validators: Validators<PayrollFormData> = {
    dateFrom: [required({ message: 'Date from is required.' }), maxLength({ max: 255 })],
    dateTo: [required({ message: 'Date To is required.' }), maxLength({ max: 255 })],
};

const PayrollForm: React.FunctionComponent<InjectedProps & PayrollFormProps> = ({
    handleSubmit,
    providersPayroll,
    findProviders,
    handleSub,
    error,
    dirty,
    isFindProviders,
    stateData,
    setStateData,
    submitting,
    initialValues,
}: InjectedProps & PayrollFormProps) => {
    const isNew = !initialValues || !initialValues.id;

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />

            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <div className="container-fluid">
                <div className="row align-items-end">
                    <div className="col-md-3">
                        <FieldDate
                            name="dateFrom"
                            type="text"
                            date={true}
                            className="mr-5"
                            validate={validators.dateFrom}
                            wrapperConfig={{
                                label: 'From',
                            }}
                        />
                    </div>

                    <div className="col-md-3">
                        <FieldDate
                            name="dateTo"
                            type="text"
                            date={true}
                            max={new Date()}
                            validate={validators.dateTo}
                            wrapperConfig={{
                                label: 'To',
                            }}
                        />
                    </div>
                    <span className="col-md-4 ">
                        <button
                            type="button"
                            style={{ height: 38, marginBottom: 20 }}
                            className={classNames('btn', 'btn-primary')}
                            onClick={() => {
                                findProviders();
                            }}
                        >
                            Next
                        </button>
                    </span>
                </div>
                {isFindProviders && providersPayroll.list.length ? (
                    <div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className={'list'}>
                                    <h2 className={`${classNames('pageHeadingTitle')}`}>Providers</h2>
                                    <PrlProviderGridProviders
                                        stateData={stateData}
                                        setStateData={setStateData}
                                        data={providersPayroll}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <FieldInput
                                    name="note"
                                    type="text"
                                    wrapperConfig={{
                                        classes: {
                                            inputWrapper: 'm-0',
                                        },
                                        label: 'Note',
                                    }}
                                />
                            </div>
                        </div>
                        <div className={classNames(styles.actions)}>
                            <button
                                type="button"
                                onClick={(e) => {
                                    handleSub(handleSubmit, e);
                                }}
                                className={classNames('btn', 'btn-success', 'mr-3')}
                                disabled={!dirty || submitting || !Object.keys(stateData).length}
                            >
                                <FontAwesomeIcon icon={faSave} /> {isNew ? 'Generate' : 'Update'}
                            </button>
                            <Link
                                className={classNames('btn', 'btn-danger')}
                                to={Router.generate(routes.PAYROLLS_LIST)}
                            >
                                <FontAwesomeIcon icon={faBan} /> Cancel
                            </Link>
                        </div>
                    </div>
                ) : null}
            </div>
        </form>
    );
};

export default reduxForm<PayrollFormData, PayrollFormProps>({
    form: 'payroll-form',
    onSubmit: async (data: PayrollFormData, dispatch: Dispatch<any>, props: PayrollFormProps) => {
        await asyncPersistPayroll(
            { ...data, providers: props.stateData },
            //props.files,
            dispatch,
        );
    },
    onSubmitSuccess() {
        toast.success('Payroll was successfully added');
    },

    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(PayrollForm);
